/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MeteredDataSource = {
    NotSpecified: 'NotSpecified',
    Sent: 'Sent',
    Requested: 'Requested',
} as const;
export type MeteredDataSource = typeof MeteredDataSource[keyof typeof MeteredDataSource];

